/** Wiederverwendbarer Kino-Seitenkopf · Quiet Luxury Editorial */
export default function CinemaPageHero({
  image,
  kicker,
  title,
  accent,
  sub,
  children,
  testId,
  topPad = "pt-48",
  imagePosition = "center",
}) {
  return (
    <section data-testid={testId} className="relative min-h-[60vh] flex flex-col overflow-hidden bg-espresso-deep">
      <img
        src={image}
        alt=""
        className="absolute inset-0 w-full h-full object-cover kenburns-slow"
        style={{ objectPosition: imagePosition }}
        loading="eager"
      />
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{ background: "linear-gradient(to bottom, rgba(24,21,18,0.5) 0%, rgba(24,21,18,0.2) 35%, rgba(24,21,18,0.45) 65%, rgba(24,21,18,0.92) 100%)" }}
      />
      <div
        aria-hidden="true"
        className="absolute inset-0 pointer-events-none"
        style={{ background: "linear-gradient(to right, rgba(24,21,18,0.55) 0%, rgba(24,21,18,0.2) 50%, rgba(24,21,18,0) 80%)" }}
      />
      <div className="relative z-10 mt-auto w-full">
        <div className={`max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 ${topPad} pb-14`}>
          <div className="flex items-center gap-3.5 hero-rise">
            <span className="text-[11px] uppercase tracking-[0.34em] font-bold text-brand-rose">{kicker}</span>
            <span className="h-px w-14 bg-saffron-dark" />
          </div>
          <h1 className="font-magazine text-cream-50 font-bold leading-[1.08] text-[2.6rem] sm:text-[3.6rem] lg:text-[4.4rem] mt-6 hero-rise" style={{ animationDelay: "150ms" }}>
            {title} <em className="italic text-brand-rose">{accent}</em>
          </h1>
          {sub && (
            <p className="mt-6 text-cream-100/90 text-[15.5px] sm:text-[16px] leading-[1.75] max-w-2xl hero-rise" style={{ animationDelay: "300ms" }}>
              {sub}
            </p>
          )}
          {children}
        </div>
      </div>
    </section>
  );
}
